/**
 * Half-Yard Quantity Selector for The Shiplap Quilt Shop
 * FSA (Fabric Shop App) Compatible
 *
 * Replaces FSA's default quantity selector with a custom half-yard selector
 * Only activates on products where FSA is configured (data-fsa-is-fractional="true")
 * Works with FSA's multiplier/divider system
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    minYards: 0.5,
    maxYards: 10,
    increment: 0.5,

    // Multiplier for converting yards to Shopify units
    // Since Shopify inventory is whole numbers: 0.5 yards = 1 unit, 1.0 yards = 2 units
    yardsToUnitsMultiplier: 2,

    // FSA selectors (from fsa-input-product.liquid)
    fsaContainerSelector: '[data-fsa-container-product]',
    fsaInputSelector: '[data-fsa-input]',
    fsaHiddenQuantitySelector: '[data-fsa-hidden-quantity]',
    fsaMinusSelector: '[data-fsa-minus]',
    fsaPlusSelector: '[data-fsa-plus]',

    // Boost quick view selectors
    boostQuickViewSelector: '.boost-sd__quick-view-quantity',
    boostInputSelector: '.boost-sd__input-number-input'
  };

  /**
   * Check if this product should use the half-yard selector
   * Activates on products tagged with "Fractional Yardage"
   */
  function shouldEnableSelector(container) {
    // Check for "Fractional Yardage" tag in data attribute (exact match)
    const productTags = container.getAttribute('data-product-tags') || '';
    const hasYardageTag = productTags.toLowerCase().split(',').some(tag =>
      tag.trim() === 'fractional yardage'
    );

    console.log(`[Half-Yard] Product tags: "${productTags}", Has fractional yardage tag: ${hasYardageTag}`);

    return hasYardageTag;
  }

  /**
   * Initialize half-yard selector for Boost quick view
   * TODO: Fix Yardage property not being added to cart from quick view
   * The fetch/XHR interceptors aren't working - need to find Boost's actual add to cart mechanism
   */
  /*
  function initBoostQuickView() {
    console.log('[Half-Yard] Looking for Boost quick view...');

    const quickView = document.querySelector(CONFIG.boostQuickViewSelector);
    if (!quickView || quickView.hasAttribute('data-yards-initialized')) {
      return;
    }

    // Check if this is a yardage product by looking at the quick view content
    const quickViewContent = document.querySelector('.boost-sd__quick-view');
    if (!quickViewContent) return;

    // For now, assume all fabric products use yards
    // TODO: Add better detection based on product type or tags
    const isFabric = quickViewContent.textContent.includes('yard') ||
                     quickViewContent.textContent.includes('Fabric');

    if (!isFabric) {
      console.log('[Half-Yard] Not a fabric product, skipping');
      return;
    }

    const input = quickView.querySelector(CONFIG.boostInputSelector);
    if (!input) return;

    console.log('[Half-Yard] Initializing Boost quick view selector');

    // Get current value in units
    const currentUnits = parseInt(input.value) || 2; // Default to 1 yard (2 units)
    const currentYards = currentUnits / CONFIG.yardsToUnitsMultiplier;

    // Create custom selector
    const customWrapper = createQuantityWrapper(currentYards, {
      min: CONFIG.minYards * CONFIG.yardsToUnitsMultiplier,
      max: CONFIG.maxYards * CONFIG.yardsToUnitsMultiplier
    });

    // Make buttons smaller for quick view
    customWrapper.style.cssText = 'display: flex; align-items: center; gap: 8px;';
    const qvMinusBtn = customWrapper.querySelector('.half-yard-minus');
    const qvPlusBtn = customWrapper.querySelector('.half-yard-plus');
    const qvDropdown = customWrapper.querySelector('.half-yard-selector');

    if (qvMinusBtn) qvMinusBtn.style.cssText = 'padding: 8px 12px; font-size: 14px; min-width: 36px;';
    if (qvPlusBtn) qvPlusBtn.style.cssText = 'padding: 8px 12px; font-size: 14px; min-width: 36px;';
    if (qvDropdown) qvDropdown.style.cssText = 'padding: 8px; font-size: 14px; max-width: 120px;';

    // Hide Boost's input
    input.style.display = 'none';

    // Insert custom selector
    quickView.insertBefore(customWrapper, quickView.querySelector('.boost-sd__input-number'));

    // Set up syncing
    const dropdown = customWrapper.querySelector('.half-yard-selector');
    const minusBtn = customWrapper.querySelector('.half-yard-minus');
    const plusBtn = customWrapper.querySelector('.half-yard-plus');

    // Find the add to cart form in quick view
    const quickViewForm = quickView.closest('form') || document.querySelector('.boost-sd__quick-view form');
    let yardagePropertyInput = null;

    if (quickViewForm) {
      // Create hidden input for Yardage property
      yardagePropertyInput = document.createElement('input');
      yardagePropertyInput.type = 'hidden';
      yardagePropertyInput.name = 'properties[Yardage]';
      quickViewForm.appendChild(yardagePropertyInput);
      console.log('[Half-Yard] Created Yardage property input for Boost quick view');
    }

    function syncQuantity(yards) {
      dropdown.value = yards;
      const units = yards * CONFIG.yardsToUnitsMultiplier;
      input.value = units;

      // Update Yardage property
      if (yardagePropertyInput) {
        const yardText = yards === 1 ? 'yard' : 'yards';
        yardagePropertyInput.value = `${yards} ${yardText}`;
      }

      minusBtn.disabled = (yards <= CONFIG.minYards);
      plusBtn.disabled = (yards >= CONFIG.maxYards);

      console.log(`[Half-Yard] Boost QV synced: ${yards} yards = ${units} units`);
    }

    minusBtn.addEventListener('click', () => {
      const newYards = Math.max(CONFIG.minYards, parseFloat(dropdown.value) - CONFIG.increment);
      syncQuantity(newYards);
    });

    plusBtn.addEventListener('click', () => {
      const newYards = Math.min(CONFIG.maxYards, parseFloat(dropdown.value) + CONFIG.increment);
      syncQuantity(newYards);
    });

    dropdown.addEventListener('change', (e) => {
      syncQuantity(parseFloat(e.target.value));
    });

    // Track current yardage for fetch interceptor
    let currentYardage = `${currentYards} ${currentYards === 1 ? 'yard' : 'yards'}`;

    // Wrap syncQuantity to update currentYardage
    const originalSyncQuantity = syncQuantity;
    syncQuantity = function(yards) {
      originalSyncQuantity(yards);
      currentYardage = `${yards} ${yards === 1 ? 'yard' : 'yards'}`;
    };

    syncQuantity(currentYards);
    quickView.setAttribute('data-yards-initialized', 'true');

    // Intercept fetch calls to /cart/add.js from quick view
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];

      console.log('[Half-Yard] Fetch called:', url);

      // Check if this is a cart add request
      if (url && url.includes('/cart/add')) {
        console.log('[Half-Yard] Cart add detected!');

        // Modify the request to include Yardage property
        if (args[1] && args[1].body) {
          try {
            const body = JSON.parse(args[1].body);
            console.log('[Half-Yard] Original body:', body);

            // Add Yardage property
            if (!body.properties) {
              body.properties = {};
            }
            body.properties.Yardage = currentYardage;

            // Update the request body
            args[1].body = JSON.stringify(body);
            console.log('[Half-Yard] Modified body with Yardage:', currentYardage);
          } catch (e) {
            console.error('[Half-Yard] Error modifying cart add request:', e);
          }
        }
      }

      return originalFetch.apply(this, args);
    };

    // Also intercept XMLHttpRequest in case Boost uses that
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._url = url;
      return originalXHROpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function(body) {
      console.log('[Half-Yard] XHR send:', this._url);

      if (this._url && this._url.includes('/cart/add')) {
        console.log('[Half-Yard] Cart add via XHR detected!');

        try {
          if (body) {
            const data = JSON.parse(body);
            console.log('[Half-Yard] Original XHR body:', data);

            if (!data.properties) {
              data.properties = {};
            }
            data.properties.Yardage = currentYardage;

            body = JSON.stringify(data);
            console.log('[Half-Yard] Modified XHR body with Yardage:', currentYardage);
          }
        } catch (e) {
          console.error('[Half-Yard] Error modifying XHR request:', e);
        }
      }

      return originalXHRSend.apply(this, [body]);
    };

    console.log('[Half-Yard] Installed fetch + XHR interceptors for quick view');


    // Update price to show per-yard (2 units) for fabric items
    const priceElement = document.querySelector('.boost-sd__quick-view-price');
    if (priceElement && !priceElement.hasAttribute('data-price-converted')) {
      const priceText = priceElement.textContent;
      const priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);

      if (priceMatch) {
        const unitPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
        const yardPrice = unitPrice * CONFIG.yardsToUnitsMultiplier;

        // Replace the price text with "/yard"
        priceElement.textContent = priceElement.textContent.replace(priceMatch[0], `$${yardPrice.toFixed(2)}/yard`);
        priceElement.setAttribute('data-price-converted', 'true');

        console.log('[Half-Yard] Price converted from', `$${unitPrice}`, 'to', `$${yardPrice}`, '(per yard)');
      }
    }

    console.log('[Half-Yard] Boost quick view initialized!');
  }
  */

  /**
   * Initialize the half-yard selector
   * @param {boolean} force - Force re-initialization even if already initialized
   */
  function initQuantitySelector(force = false) {
    console.log('[Half-Yard] Looking for FSA containers... (force:', force, ')');

    const containers = document.querySelectorAll(CONFIG.fsaContainerSelector);

    if (containers.length === 0) {
      console.log('[Half-Yard] No FSA containers found');
      return;
    }

    containers.forEach(container => {
      // STRONG GUARD: Check if wrapper already exists
      if (container.querySelector('.half-yard-quantity-wrapper')) {
        console.log('[Half-Yard] Wrapper already exists, skipping');
        return;
      }

      // Skip if already initialized (unless force=true)
      if (!force && container.hasAttribute('data-half-yard-initialized')) {
        console.log('[Half-Yard] Already initialized, skipping');
        return;
      }

      // Only initialize visible containers (unless force=true)
      const isVisible = container.offsetParent !== null;
      if (!force && !isVisible) {
        console.log('[Half-Yard] Skipping hidden container');
        return;
      }

      // Check if this product should use half-yard selector
      if (!shouldEnableSelector(container)) {
        console.log('[Half-Yard] Keeping standard FSA selector for non-yardage product');
        return;
      }

      console.log('[Half-Yard] Creating half-yard selector...');

      // Get FSA data attributes
      const fsaData = {
        step: parseFloat(container.getAttribute('data-fsa-step')),
        min: parseFloat(container.getAttribute('data-fsa-min')),
        max: parseFloat(container.getAttribute('data-fsa-max')),
        current: parseFloat(container.getAttribute('data-fsa-current-quantity')),
        multiplier: parseFloat(container.getAttribute('data-fsa-multiplier')),
        divider: parseFloat(container.getAttribute('data-fsa-multiplier')) // FSA uses same value for display
      };

      console.log('[Half-Yard] FSA data:', fsaData);

      // Find FSA elements
      const fsaInput = container.querySelector(CONFIG.fsaInputSelector);
      const hiddenQuantity = container.querySelector(CONFIG.fsaHiddenQuantitySelector);
      const fsaMinus = container.querySelector(CONFIG.fsaMinusSelector);
      const fsaPlus = container.querySelector(CONFIG.fsaPlusSelector);

      if (!fsaInput || !hiddenQuantity) {
        console.log('[Half-Yard] Required FSA inputs not found');
        return;
      }

      // Get current value in yards (from FSA input)
      const currentYards = parseFloat(fsaInput.value) || 1.0;

      // Create our custom selector
      const customWrapper = createQuantityWrapper(currentYards, fsaData);

      // Hide FSA's visible controls (but keep hidden quantity input)
      fsaInput.style.display = 'none';
      if (fsaMinus) fsaMinus.style.display = 'none';
      if (fsaPlus) fsaPlus.style.display = 'none';

      // Also hide the entire FSA wrapper to prevent duplicates
      const fsaWrapper = container.querySelector('.fsa-quantity-wrapper, [data-fsa-wrapper]');
      if (fsaWrapper) {
        fsaWrapper.style.display = 'none';
      }

      // Insert our custom wrapper
      container.insertBefore(customWrapper, container.firstChild);

      // Mark container as initialized to prevent duplicate processing
      container.setAttribute('data-half-yard-initialized', 'true');

      // Set up syncing
      const dropdown = customWrapper.querySelector('.half-yard-selector');
      const minusBtn = customWrapper.querySelector('.half-yard-minus');
      const plusBtn = customWrapper.querySelector('.half-yard-plus');

      // Create or find line item property input for yardage display
      const productForm = container.closest('form[action*="/cart/add"]');
      let yardagePropertyInput = null;

      if (productForm) {
        // Check if property input already exists
        yardagePropertyInput = productForm.querySelector('input[name="properties[Yardage]"]');

        if (!yardagePropertyInput) {
          // Create hidden input for line item property
          yardagePropertyInput = document.createElement('input');
          yardagePropertyInput.type = 'hidden';
          yardagePropertyInput.name = 'properties[Yardage]';
          productForm.appendChild(yardagePropertyInput);
          console.log('[Half-Yard] Created line item property input');
        }
      }

      // Sync function
      function syncQuantity(yards) {
        // Update dropdown
        dropdown.value = yards;

        // Update FSA's visible input (even though hidden)
        fsaInput.value = yards;

        // Update FSA's hidden quantity input (what actually gets submitted)
        // Convert yards to Shopify units using our multiplier
        // Example: 1.5 yards × 2 = 3 units
        const shopifyUnits = yards * CONFIG.yardsToUnitsMultiplier;
        hiddenQuantity.value = shopifyUnits;

        // Update line item property to show yardage in cart/checkout
        if (yardagePropertyInput) {
          const yardText = yards === 1 ? 'yard' : 'yards';
          yardagePropertyInput.value = `${yards} ${yardText}`;
          console.log(`[Half-Yard] Line item property: ${yardagePropertyInput.value}`);
        }

        // Update button states
        minusBtn.disabled = (yards <= CONFIG.minYards);
        plusBtn.disabled = (yards >= CONFIG.maxYards || yards >= fsaData.max / CONFIG.yardsToUnitsMultiplier);

        // Trigger FSA's change event (in case it has listeners)
        hiddenQuantity.dispatchEvent(new Event('change', { bubbles: true }));

        console.log(`[Half-Yard] Synced: ${yards} yards = ${shopifyUnits} Shopify units`);
      }

      // Event handlers
      minusBtn.addEventListener('click', () => {
        const newYards = Math.max(CONFIG.minYards, parseFloat(dropdown.value) - CONFIG.increment);
        syncQuantity(newYards);
      });

      plusBtn.addEventListener('click', () => {
        const maxYards = Math.min(CONFIG.maxYards, fsaData.max / CONFIG.yardsToUnitsMultiplier);
        const newYards = Math.min(maxYards, parseFloat(dropdown.value) + CONFIG.increment);
        syncQuantity(newYards);
      });

      dropdown.addEventListener('change', (e) => {
        syncQuantity(parseFloat(e.target.value));
      });

      // Set initial state
      syncQuantity(currentYards);

      // Price conversion now handled in Liquid template (main-product.liquid)
      // No need to update via JavaScript - prevents flash on page load

      console.log('[Half-Yard] Selector initialized successfully');
    });
  }

  /**
   * Update product page price to show per-yard (2 units)
   * ONLY for products tagged with "Fractional Yardage"
   */
  function updateProductPagePrice(container) {
    // Check for "Fractional Yardage" tag (exact match, same logic as shouldEnableSelector)
    const productTags = container.getAttribute('data-product-tags') || '';
    const hasYardageTag = productTags.toLowerCase().split(',').some(tag =>
      tag.trim() === 'fractional yardage'
    );

    if (!hasYardageTag) {
      console.log('[Half-Yard] Not a fractional yardage product, skipping price conversion');
      return;
    }

    // Find the product price element (various possible selectors)
    const priceSelectors = [
      '.product-price .theme-money',
      '.price .theme-money',
      '[data-product-price]',
      '.product__price .theme-money'
    ];

    let priceElement = null;
    for (const selector of priceSelectors) {
      priceElement = container.closest('form')?.querySelector(selector) ||
                     document.querySelector(selector);
      if (priceElement) break;
    }

    if (!priceElement || priceElement.hasAttribute('data-price-converted')) {
      return;
    }

    const priceText = priceElement.textContent;
    const priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);

    if (priceMatch) {
      const unitPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
      const yardPrice = unitPrice * CONFIG.yardsToUnitsMultiplier;

      // Replace the price with per-yard price
      priceElement.textContent = `$${yardPrice.toFixed(2)}/yard`;
      priceElement.setAttribute('data-price-converted', 'true');

      console.log('[Half-Yard] Product price converted from', `$${unitPrice}`, 'to', `$${yardPrice}/yard`);
    }
  }

  /**
   * Create the custom quantity wrapper
   */
  function createQuantityWrapper(initialYards, fsaData) {
    const wrapper = document.createElement('div');
    wrapper.className = 'half-yard-quantity-wrapper';

    // Minus button
    const minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.className = 'half-yard-btn half-yard-minus';
    minusBtn.textContent = '−';
    minusBtn.setAttribute('aria-label', 'Decrease quantity');

    // Dropdown
    const maxYards = Math.min(CONFIG.maxYards, fsaData.max / CONFIG.yardsToUnitsMultiplier);
    const dropdown = createDropdown(initialYards, maxYards);

    // Plus button
    const plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'half-yard-btn half-yard-plus';
    plusBtn.textContent = '+';
    plusBtn.setAttribute('aria-label', 'Increase quantity');

    wrapper.appendChild(minusBtn);
    wrapper.appendChild(dropdown);
    wrapper.appendChild(plusBtn);

    return wrapper;
  }

  /**
   * Create the dropdown selector
   */
  function createDropdown(initialYards, maxYards) {
    const select = document.createElement('select');
    select.className = 'half-yard-selector';
    select.setAttribute('aria-label', 'Select yardage');

    // Generate options
    for (let yards = CONFIG.minYards; yards <= maxYards; yards += CONFIG.increment) {
      const option = document.createElement('option');
      option.value = yards;

      // Format display text
      const yardText = yards === 1 ? 'yard' : 'yards';
      option.textContent = `${yards} ${yardText}`;

      if (Math.abs(yards - initialYards) < 0.01) { // Float comparison
        option.selected = true;
      }

      select.appendChild(option);
    }

    return select;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantitySelector);
  } else {
    initQuantitySelector();
  }

  // Re-initialize for AJAX/dynamic content
  document.addEventListener('shopify:section:load', initQuantitySelector);

  // Watch for quick view / dynamic modals
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        // Check if the added node contains FSA containers
        if (node.nodeType === 1) { // Element node
          const hasContainer = node.querySelector && node.querySelector(CONFIG.fsaContainerSelector);
          const isContainer = node.matches && node.matches(CONFIG.fsaContainerSelector);

          if (hasContainer || isContainer) {
            console.log('[Half-Yard] Detected dynamic FSA container, initializing...');
            setTimeout(initQuantitySelector, 200);
          }
        }
      });
    });
  });

  // Start observing for quick view modals and dynamic content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Listen for quick view button clicks
  document.addEventListener('click', function(e) {
    const quickViewBtn = e.target.closest('.boost-sd__button--quick-view, [aria-label="Quick view"], [data-quick-view], .quick-view, .quickbuy-toggle, .js-modal-open-quick-buy, .quickbuy__toggle');
    if (quickViewBtn) {
      console.log('[Half-Yard] Quick view button clicked, will poll for quantity selector...');

      // Poll for quantity selector until it appears (Boost loads via AJAX)
      let pollAttempts = 0;
      const maxAttempts = 20; // Try for 4 seconds (20 * 200ms)

      const pollInterval = setInterval(() => {
        pollAttempts++;

        // Check for both FSA containers and Boost quick view
        const fsaContainers = document.querySelectorAll(CONFIG.fsaContainerSelector);
        const boostQuickView = document.querySelector(CONFIG.boostQuickViewSelector);

        if (fsaContainers.length > 0) {
          console.log('[Half-Yard] FSA container found after', pollAttempts * 200, 'ms! Initializing...');
          clearInterval(pollInterval);
          initQuantitySelector(); // Don't force - let the guard check if already initialized
        }
        /* TODO: Re-enable when quick view Yardage property issue is fixed
        else if (boostQuickView) {
          console.log('[Half-Yard] Boost quick view found after', pollAttempts * 200, 'ms! Initializing...');
          clearInterval(pollInterval);
          initBoostQuickView();
        }
        */
        else if (pollAttempts >= maxAttempts) {
          console.log('[Half-Yard] Quantity selector not found after', maxAttempts * 200, 'ms, giving up.');
          clearInterval(pollInterval);
        }
      }, 200); // Check every 200ms
    }
  });

  // Periodic check disabled - MutationObserver and event listeners are sufficient
  // This was causing duplicate initializations
  /*
  setInterval(function() {
    const uninitializedContainers = document.querySelectorAll(CONFIG.fsaContainerSelector + ':not([data-half-yard-initialized])');
    if (uninitializedContainers.length > 0) {
      console.log('[Half-Yard] Found', uninitializedContainers.length, 'uninitialized containers, initializing...');
      initQuantitySelector();
    }
  }, 2000);
  */

})();
